import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../theme/ISpcTheme';

export type ConfiguratorControlsLayoutClasses = 'controlsContainer';

const configuratorControlsLayoutStyles = makeStyles<ISpcTheme, ConfiguratorControlsLayoutClasses>(
  theme => ({
    controlsContainer: {
      padding: '0 48px 48px 56px',
      [theme.breakpoints.down('md')]: {
        padding: '0 16px',
      },
      [theme.breakpoints.up('md')]: theme.spc.rightHandPanelFixedWidthSize
        ? {
            maxWidth: theme.spc.rightHandPanelFixedWidthSize,
            flexBasis: '100%',
          }
        : {},
    },
  }),
  { name: 'Common_ConfiguratorControlsLayout' },
);

export default configuratorControlsLayoutStyles;
